export default __webpack_public_path__ + "static/media/view-counts.7eb76f4b.svg";